import 'css-chunksrc/client/scenes/workloads/wbs/milestone/nameEditionForm/styles.scss';export default {
  "nameEditionForm": "_nameEditionForm_rpvdf_1",
  "form": "_form_rpvdf_6",
  "hovered": "_hovered_rpvdf_10",
  "name": "_name_rpvdf_1",
  "icon": "_icon_rpvdf_32",
  "input": "_input_rpvdf_36",
  "edition": "_edition_rpvdf_57",
  "tooltip": "_tooltip_rpvdf_64"
};